var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C5.243 0 3 2.243 3 5v3H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V5c0-2.757-2.243-5-5-5ZM5 5c0-1.654 1.346-3 3-3s3 1.346 3 3v3H5V5Zm4 10.723V18H7v-2.277a1.993 1.993 0 0 1 .567-3.677A2 2 0 0 1 10 14a1.99 1.99 0 0 1-1 1.723Z",
  fill: "#9c9c97"
})));
export default SvgLockIcon;